<template>
  <div
    class="ff-page-search"
    :data-ref="trigger"
  >
    <ff-menu
      class="menu"
      :items="items"
      :class="{'is-active': show}"
      :style="style"
      :showInput="true"
      :trigger="trigger"
      @action="bubbleAction"
      @input="search"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import fuzzysearch from 'fuzzysearch'
import FFMenu from './FFMenu'

export default {
  name: 'ff-page-search',
  components: {
    'ff-menu': FFMenu,
  },
  props: ['e'],
  data () {
    return {
      deactivated: false,
      show: false,
      menu_top: 10,
      menu_right: 10,
      items: [{
        title: 'No Parent',
        id: null
      }],
      first: true,
    }
  },
  computed: {
    style () {
      let s = {}
      s.top = this.menu_top
      s.right = this.menu_right
      return s
    },
    trigger () {
      return `trigger-${Date.now()}`
    },
    parent_id () {
      if (this.page && this.page.parent) return this.page.parent;
      return null;
    },
    ...mapState(['channel', 'page_id', 'page'])
  },
  methods: {
    showMenu () {
      let w = window.innerWidth
      let r = w - this.e.clientX
      this.menu_top = `${this.e.clientY}px`
      this.menu_right =`${r}px`
      this.show = true
    },
    bubbleAction (item) {
      this.$emit('action', item)
    },
    showRecent () {
      if (this.parent_id) {
        this.items = [this.items[0]]
      } else {
        this.items = []
      }

      this.items.push(
        ...this.channel.pages
        .filter(this.filterCurrent)
        .slice(0, 3)
        .reverse()
        .map((item) => ({
          title: item.title,
          id: item.id
        }))
      )
    },
    filterCurrent(val) {
      return val.id !== this.page_id && this.parent_id !== val.id
    },
    search(input) {
      if (input) {
        if (this.parent_id) {
          this.items = [this.items[0]]
        } else {
          this.items = []
        }
        this.items.push(
          ...this.channel.pages
            .filter((val) => this.filterCurrent(val) && fuzzysearch(input.toLowerCase(), val.title.toLowerCase()))
            .slice(0, 10)
            .map((item) => ({
              title: item.title,
              id: item.id
            }))
        )
      } else {
        this.showRecent()
      }
    },
    onClick(e) {
      // throw out the first event because it's not for us
      if (this.first) {
        this.first = false
        return
      }
      const t = e.target.attributes['data-ref']
      if (!t || t.nodeValue !== this.trigger) {
        this.show = false
        this.$emit('close')
      }
    }
  },
  mounted () {
    // map initial set of pages
    if (this.channel && this.channel.pages) {
      this.showRecent()
    }

    if (this.e) {
      this.showMenu()
    }

    document.addEventListener('click', this.onClick)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.onClick)
  }
}
</script>

<style scoped lang="scss">
  @import "../../assets/styles/app.scss";

  @keyframes show {
    0% {
      opacity: 0;
      transform: translate3d(0, .5rem, 0);
    }
    100% {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .menu {
    position: absolute;
    display: none;

    &.is-active {
      display: block;
      animation: show .12s ease;
    }
  }

</style>
